<template>
  <v-form ref="settings">
    <v-container style="padding: 3% 3% 2% 3%;">
      <v-row>
        <v-col cols="3">
          <v-select
            v-model="settings.algorithmType"
            label="Algoritma Tipi"
            :items="algorithmTypes"
            hide-details
            :rules="[rules.required]"
          ></v-select>
        </v-col>
        <v-col cols="3">
          <v-select
            v-model="settings.yuklenimSelection"
            label="İndirilecek KDV Listesi"
            :items="kdvRateSelectionItems"
            hide-details
            :rules="[rules.required]"
          ></v-select>
        </v-col>
        <v-col cols="3" v-if="loggedAdmin.isSuperAdmin">
          <v-menu
            ref="DeadlineDate"
            v-model="DeadlineDateMenu"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="DeadlineDate"
                label="Son Kullanma Tarihi"
                persistent-hint
                v-bind="attrs"
                v-on="on"
                :rules="[rules.required]"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="DeadlineDate"
              no-title
              locale="tr-tr"
              @input="DeadlineDateMenu = false"
              @blur="DeadlineDate = parseDate(DeadlineDate)"
              :rules="[rules.required]"
            ></v-date-picker>
          </v-menu>
        </v-col>
        <v-col v-if="loggedAdmin.isSuperAdmin">
          <v-checkbox
          style=" margin-left:1%"
          v-model="periodCheckBox"
          label="Dönem Aralığı"
          ></v-checkbox>
        </v-col>
        <v-col v-if="loggedAdmin.isSuperAdmin">
         <v-btn 
            @click="databaseChoiceDialogOpenFunc()"
            color="primary"
          >
            Veri Tabanı Seçimi
          </v-btn>
        </v-col>
        <v-col cols="3" v-if="loggedAdmin.isSuperAdmin">
          
        </v-col>
        <v-dialog v-model="periodDialog" width="35%" persistent>
          <v-card>
            <v-card-title>
              <span>{{ "Kısıtlama İçin Dönem Aralığı Giriniz" }}</span>
            </v-card-title>
            <v-form v-model="valid">
              <v-container>
                <v-row>
                  <v-col cols="12" md="6" style="padding-left: 12;padding-right: 12;padding-bottom: 0;padding-top: 0">
                    <v-dialog
                      ref="dialog"
                      v-model="modal"
                      :return-value.sync="startingPeriod"
                      persistent
                      width="290px"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="startingPeriod"
                          label="Başlangıç Dönemi"
                          prepend-icon="mdi-calendar"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                          :rules="[rules.required]"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="startingPeriod"
                        type="month"
                        scrollable
                        locale="tr"
                      >
                        <v-spacer></v-spacer>
                        <v-btn text color="primary" @click="modal = false">İptal</v-btn>
                        <v-btn text color="primary" @click="$refs.dialog.save(startingPeriod)">Tamam</v-btn>
                      </v-date-picker>
                    </v-dialog>
                  </v-col>
                  <v-col cols="12" md="6" style="padding-left: 12;padding-right: 12;padding-bottom: 0;padding-top: 0">
                    <v-dialog
                      ref="dialog1"
                      v-model="modal1"
                      :return-value.sync="endPeriod"
                      persistent
                      width="290px"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="endPeriod"
                          label="Bitiş Tarihi"
                          prepend-icon="mdi-calendar"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                          :rules="[rules.required]"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="endPeriod"
                        type="month"
                        scrollable
                        locale="tr"
                      >
                        <v-spacer></v-spacer>
                        <v-btn text color="primary" @click="modal1 = false">İptal</v-btn>
                        <v-btn text color="primary" @click="$refs.dialog1.save(endPeriod)">Tamam</v-btn>
                      </v-date-picker>
                    </v-dialog>
                  </v-col>
                </v-row>
              </v-container>
            </v-form>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="periodDialogClose(0)">İptal</v-btn>
              <v-btn
                :disabled="!valid"
                color="blue darken-1"
                text
                @click="periodDialogClose(1)"
                >Kaydet</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
      <hr style="margin 1% 0" />
      <v-btn color="blue darken-1" style="float: right;" text @click="save()">
        değişiklikleri kaydet
      </v-btn>
    </v-container>
    <v-dialog v-model="databaseChoiceDialog" max-width="1250px" persistent>
      <v-card>
        <v-card-title>
          <span class="headline">{{addDatabaseInfoHeadLine}}</span>
        </v-card-title>
        <v-form v-model="databaseChoiceDialogValid">
          <v-container>
            <v-row>
              <v-col cols="12" md="4">
                <v-select
                  v-model="newDatabaseChoiceObj.year"
                  label="Yılı Seçiniz"
                  :items="yearItems"
                  hide-details
                  :rules="[rules.required]"
                ></v-select>
              </v-col>
              <v-col cols="12" md="4">
                <v-select
                  v-model="newDatabaseChoiceObj.erpChoice"
                  label="Erp Seçimi"
                  :items="erpItems"
                  hide-details
                  :rules="[rules.required]"
                ></v-select>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" text @click="databaseChoiceDialogCloseFunc()">İptal</v-btn>
          <v-btn
            :disabled="!databaseChoiceDialogValid"
            color="blue darken-1"
            text
            @click="databaseChoiceDialogSaveFunc()" 
          >Kaydet</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="addDatabaseInfoDialog" width="60%" persistent>
      <v-card>
        <v-tabs
          v-model="addDataBaseTab"
          background-color="blue lighten-2"
          dark
        >
          <v-tab
            v-for="n in descriptionLength"
            :key="n.headers"
          >
          {{ n.headers }}
          </v-tab>
        </v-tabs>
        <v-tabs-items v-model="addDataBaseTab">
          <v-tab-item
            v-for="(descriptionLength) in descriptionLength"
            :key="descriptionLength.headers"
          > 
            <template v-if="descriptionLength.choice == 'Netsis'">
              <v-col style="margin-left:18%" cols="8">
                  <!-- <v-textarea
                      height="100%"
                      :key="descriptionLength.items"
                      outlined
                      v-model="despricationObj[i]"
                      label ="Notlarınız"
                  ></v-textarea> -->
                   <v-text-field
                      v-model="descriptionLength.branchCode"
                      label="Şube Kodu"
                      :rules="[rules.required]"
                    ></v-text-field>
                    <v-text-field
                      v-model="descriptionLength.dbName"
                      label="Veri Tabanı Adı"
                      :rules="[rules.required]"
                    ></v-text-field>
              </v-col>
            </template>
            <template v-if="descriptionLength.choice == 'Canias'">
              <v-col style="margin-left:18%" cols="8">
                <v-text-field
                   v-model="descriptionLength.username"
                   label="Kullanıcı Adı"
                   :rules="[rules.required]"
                 ></v-text-field>
                 <v-text-field
                   v-model="descriptionLength.password"
                   label="Şifre"
                   :rules="[rules.required]"
                 ></v-text-field>
              </v-col>
            </template>
          </v-tab-item>
        </v-tabs-items>
        <v-card-text class="text-center">
            <v-btn
                text
                @click="newDescriptionTab('delete', descriptionLength)"
            >
            Bu Yılı Sil
            </v-btn>
            <v-divider
              class="mx-4"
              vertical
            ></v-divider>
            <v-btn
              text
              @click="newDescriptionTab('add')"
            >
              Yeni Yıl Ekle
            </v-btn>
            <v-btn
              text
              @click="newDescriptionTab('close')" 
            >
              Kapat
            </v-btn>
            <v-btn
              text
              @click="newDescriptionTab('cancel')"
            >
              İptal Et
            </v-btn>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-form>
  
  
</template>

<script>
import * as userReq from "../../request/user.js"
import { mapState} from "vuex";
export default {
  props: ["company", "popUpStatus"],
  name: "CompanySettings",
  data() {
    return {
      addDataBaseTab : null,
      despricationObj : {},
      descriptionLength : [],
      addDatabaseInfoDialog : false,
      yearItems : [
        "2010","2011","2012","2013","2014","2015","2016","2017","2018","2019","2020","2021","2022"
      ],
      erpItems : [
        "Canias", "S.A.P", "Netsis"
      ],
      newDatabaseChoiceObj : {
        year : "",
        erpChoice : ""
      },
      databaseChoiceDialogValid : false,
      databaseChoiceDialog : false,
      addDatabaseInfoHeadLine : "Veri Tabanı Seçimi",
      modal1: false,
      modal: false,
      DeadlineDateMenu: false,
      periodCheckBox: false,
      startingPeriod: null,
      endPeriod: null,
      periodDialog: false,
      valid: false,
      kdvRateSelectionItems: ["Oranlama", "Maksimum"],
      algorithmTypes: ["FIFO","LIFO"],
      rules: {
        required: (value) => !!value || "Gerekli.",
        counter: (value) => value.length >= 5 || "En az 5 karakter",
        email: (value) => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || "Geçersiz Email";
        },
      },
      settings: {},
      DeadlineDate: "",
    }
  },
  watch: {
    popUpStatus() {
      this.loadData()
    },
    "periodCheckBox": function (newValue) {
      if (newValue) {
        this.periodDialog = true
      }
    },
  },
  computed: {
    ...mapState(["loggedAdmin"]),
  },
  methods: {
    periodDialogClose(type){
      if (type == 1) {
        console.log(this.startingPeriod.split("-")[0] + this.startingPeriod.split("-")[1])
        let startingPeriod = this.startingPeriod.split("-")[0] + this.startingPeriod.split("-")[1]
        let endPeriod = this.endPeriod.split("-")[0] + this.endPeriod.split("-")[1]
        if (endPeriod <= startingPeriod) {
          this.$store.state.snackbarErrorObj = {
            snackbar: true,
            color: "error",
            text: "Başlangıç tarihi bitiş tarihinden küçük veya eşit olamaz.",
            timeout: 2500
          };
        }else{
          this.settings.startingPeriod = this.startingPeriod
          this.settings.endPeriod = this.endPeriod
          this.periodDialog = false;
        }
      }else if(type == 0){
        this.periodCheckBox = false
        this.periodDialog = false
      }
    },
    loadData() {
      if (Object.keys(this.settings).includes("deadlineLoggedin")) {
        this.DeadlineDate  = this.settings.deadlineLoggedin
      }else{
      if (this.company.settings.startingPeriod != undefined) {
        this.startingPeriod = this.company.settings.startingPeriod
        this.endPeriod = this.company.settings.endPeriod
      }
      this.settings = { ...this.company.settings };
      this.DeadlineDate = this.company.deadlineLoggedin;
      let date = new Date(this.DeadlineDate)
      date.setHours(3);
      
      this.DeadlineDate = String(date.getFullYear())+ "-" + String(date.getMonth() + 1).padStart(2, '0') +"-"+ String(date.getDate()).padStart(2, '0')
      }
    },
    save() {
      if (this.$refs.settings.validate()) {
        if (this.loggedAdmin.isSuperAdmin == true) {
          console.log(this.settings)
          this.settings.deadlineLoggedin = this.DeadlineDate
          userReq.updateCompanyPropertyWithDeadLine(this.company.id, "settings", this.settings).then((res) => {
            if (res.data.success) {
              this.$store.state.snackbarErrorObj = {
                snackbar: true,
                color: "success",
                text: "Kaydedildi",
                timeout: 1500,
              };
              let update = {};
              update.id = this.company.id;
              update.value = this.settings;
              this.$emit("refresh");
              this.loadData()
            }
          })
          .catch((err) => {
            console.log(err);
          });
        }
        this.settings.deadlineLoggedin = this.DeadlineDate 
        userReq
          .updateCompanyProperty(this.company.id, "settings", this.settings)
          .then((res) => {
            if (res.data.success) {
              this.$store.state.snackbarErrorObj = {
                snackbar: true,
                color: "success",
                text: "Kaydedildi",
                timeout: 1500,
              };
              let update = {};
              update.id = this.company.id;
              update.value = this.settings;
              this.$emit("refresh");
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
    databaseChoiceDialogOpenFunc () {
      if (this.settings.dbInfos == undefined) {
        this.settings.dbInfos = []
      }
      let dbInfos = this.settings.dbInfos
      let dbInfosKeys = Object.keys(dbInfos)
      for (let i = 0; i < dbInfosKeys.length; i++) {
        let headers = dbInfosKeys[i]
        let erpTypeObjectKeys = Object.keys(dbInfos[dbInfosKeys[i]])
        for (let j = 0; j < erpTypeObjectKeys.length; j++) {
          dbInfos[dbInfosKeys[i]][erpTypeObjectKeys[j]].choice = erpTypeObjectKeys[j]
          dbInfos[dbInfosKeys[i]][erpTypeObjectKeys[j]].headers = headers
          this.descriptionLength.push(dbInfos[dbInfosKeys[i]][erpTypeObjectKeys[j]])
        }
      }
      // that.databaseChoiceDialog = true
      this.addDatabaseInfoDialog = true
    },
    databaseChoiceDialogSaveFunc () {
      this.descriptionLength.push({
        headers : this.newDatabaseChoiceObj.year,
        choice : this.newDatabaseChoiceObj.erpChoice
      }) 
      this.databaseChoiceDialog = false
      this.addDatabaseInfoDialog = true
    },
    newDescriptionTab (type) {
      if (type == 'add') {
        this.databaseChoiceDialog = true
      }else if (type ==  'close') {
        this.addDatabaseInfoDialog = false
        let dbInfoObj = {}
        if (this.descriptionLength.length > 0) {
          let dbInfosData = this.descriptionLength
          for (let i = 0; i < dbInfosData.length; i++) {
            if (dbInfoObj[dbInfosData[i].headers] == undefined) {
              let choice = dbInfosData[i].choice, year = dbInfosData[i].headers
              dbInfoObj[year] = {}
              dbInfoObj[year][choice] = {}
              delete dbInfosData[i].choice
              delete dbInfosData[i].headers
              dbInfoObj[year][choice] = dbInfosData[i]
            }
          }
        }
        this.settings.dbInfos = dbInfoObj
      }else if (type ==  'cancel') {
        this.descriptionLength = []
        this.addDatabaseInfoDialog = false
      }else if (type == 'delete') {
        this.descriptionLength.splice(this.addDataBaseTab, 1);
      }
    }
  },
  created() {
    this.loadData()
  },
};
</script>

<style></style>
